import React, { useEffect, useState } from "react"
import { Card, Button, Form, Row, Col, Spinner, Alert } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import { Icon } from "../../../components"
import paymentService from "../services/paymentMethodService"

const emptyMethod = { name: "", active: true }

export const PaymentMethodEdit = () => {
  const { id: rawId } = useParams()
  const isNew = !rawId || rawId === "new"
  const methodId = !isNew ? rawId : null
  const navigate = useNavigate()

  const [item, setItem] = useState(emptyMethod)
  const [loading, setLoading] = useState(Boolean(methodId))
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!methodId) {
      setLoading(false)
      return
    }
    let mounted = true
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const data = await paymentService.get(methodId)
        if (mounted) setItem(data)
      } catch (err) {
        console.error("Error loading payment method", err)
        if (mounted) setError(`Error al cargar método: ${err.message}`)
      } finally {
        if (mounted) setLoading(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [methodId])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setItem((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    setError(null)
    try {
      if (isNew) await paymentService.create(item)
      else await paymentService.update(methodId, item)
      navigate("/_payment_method")
    } catch (err) {
      console.error("Error saving payment method", err)
      setError(`Error al guardar método: ${err.message}`)
    } finally {
      setSaving(false)
    }
  }

  return (
    <Layout
      title={isNew ? "Nuevo Método" : `Editar Método #${methodId}`}
      content="container"
      loading={loading}
    >
      <Block>
        <Card body>
          {error && <Alert variant="danger">{error}</Alert>}
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Row className="g-3">
                <Col md={8}>
                  <Form.Group>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      name="name"
                      value={item.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4} className="d-flex justify-content-end">
                  <Form.Check
                    type="checkbox"
                    label="Activo"
                    name="active"
                    checked={item.active}
                    onChange={handleChange}
                  />
                </Col>
                <Col xs={12} className="text-end">
                  <Button variant="primary" type="submit" disabled={saving}>
                    {saving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                        Guardando…
                      </>
                    ) : (
                      <>
                        <Icon name="save" />
                        <span> Guardar</span>
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Card>
      </Block>
    </Layout>
  )
}
export default PaymentMethodEdit
